export const SUCCESS_SAVE = 'User details saved.';
export const USER_EDIT_URL = '/superuser/edit-user/';
